
import util from '@/util'

export default class PluginInitializer {
  constructor (Vue, contextManager) {
    this.vue = Vue
    this.contextManager = contextManager
    this.plugins = new Map()
  }

  register (plugin, { keyName = 'id', configKey, options = {} }) {
    this.plugins.set(plugin, { keyName, configKey, options })
  }

  initialize () {
    this.plugins.forEach(({ keyName, configKey, options }, plugin) => {
      const configValue = this.contextManager.getContextConfig(configKey)
      if (util.valorVazio(configValue)) {
        console.warn(`Plugin ${plugin.name || 'desconhecido'} não inicializado (configuração ausente: ${configKey})`)
        return
      }
      this.vue.use(plugin, { ...options, [keyName]: configValue })
    })
  }
}
